module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./OrgDetailView.jsx"));
	}, "OrgMgr");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrgMgr!./src/pages/bundle-org-mgmt/OrgDetail/OrgDetailView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=OrgMgr!./src/pages/bundle-org-mgmt/OrgDetail/OrgDetailView.jsx
// module chunks = 43